import apiClient from './axiosClient';

const addOnePageViewRequest = async (programId: string) => {
  return apiClient
    .post(`programs/page-view/${programId}`)
    .then((res) => res.data);
};

export default addOnePageViewRequest;
